import { Directive, ElementRef, inject, input, output } from '@angular/core';

@Directive({
  selector: '[transportFileDropZone]',
  host: {
    '(dragover)': 'showDragOverStyle($event)',
    '(dragleave)': 'hideDragOverStyle($event)',
    '(dragend)': 'hideDragOverStyle($event)',
    '(drop)': 'onFileDrop($event)',
  },
})
export class FileDropZoneDirective {
  // injections
  private readonly element = inject(ElementRef);

  // in and output
  public readonly dragClass = input<string>('');
  public readonly fileDropped = output<File>();

  protected showDragOverStyle(event: DragEvent) {
    event.preventDefault();

    const customDragCssClass = this.dragClass();
    if (!customDragCssClass) {
      return;
    }

    const cssClasses = this.element.nativeElement.classList as DOMTokenList;
    cssClasses.add(customDragCssClass);
  }

  protected hideDragOverStyle(event: DragEvent) {
    event.preventDefault();

    const customDragCssClass = this.dragClass();
    if (!customDragCssClass) {
      return;
    }

    const cssClasses = this.element.nativeElement.classList as DOMTokenList;
    cssClasses.remove(customDragCssClass);
  }

  protected onFileDrop(event: DragEvent) {
    this.hideDragOverStyle(event);
    const files = event.dataTransfer?.files;
    if (files) {
      if (files.length !== 1) {
        throw new Error('Must select exactly one file');
      }

      this.fileDropped.emit(files[0]);
    }
  }
}
